import styled from 'styled-components';
export var ShareContainer = styled.span.withConfig({
  displayName: "partials__ShareContainer",
  componentId: "sc-1r55ji3-0"
})(["display:inline-block;position:relative;cursor:pointer;"]);